<template>
  <svg :class="['c-icon', `c-icon-${name}`, `c-icon--${size}`]" viewBox="0 0 100 100" :style="styles">
    <use :xlink:href="`#c-icon-${name}`"></use>
  </svg>
</template>

<script>
  export default {
    name: 'c-icon',
    props: {
      name: {
        type: String,
        required: false,
        default: 'default'
      },
      size: {
        type: String,
        default: 'md'
      },
      color: {
        type: String,
        default: '#000'
      }
    },
    computed: {
      styles() {
        return {
          color: this.color,
          fill: this.color,
        }
      }
    }
  }
</script>

<style lang="scss">
  .c-icon {
    width: auto;

    &--sm {
      height: 1.5rem;
    }

    &--md {
      height: 1.7rem;
    }

    &--lg {
      height: 2rem;
    }

    &--xl {
      height: 2.5rem;
    }
  }
</style>


